/**
 * participantContactFields — the nine fields of an event entrant's gated
 * contact document, `gyms/{gymId}/events/{eventId}/participantContacts/{entrantId}`
 * (spec: docs/spec/10c-events-participant-contacts.md).
 *
 * Both runtimes need the list: the Cloud Functions decide what moves off the
 * participant / waitlist documents, and the client decides which keys of a
 * contact document it merges into a participant row (bookkeeping keys such as
 * `lastModifiedBy` / `updatedAt` must never overwrite the row's own).
 */

/** The fields the contact document holds (bookkeeping fields excluded). */
export const PARTICIPANT_CONTACT_FIELDS = [
  "birthYear", "allergies", "medicalNotes",
  "parentName", "parentPhone", "parentEmail",
  "parentalConsent", "parentalConsentAt", "paymentNote",
];
